import React, { HtmlHTMLAttributes } from 'react';
import styled, { StyledComponentPropsWithRef } from 'styled-components';
import { COLOR } from '../../constants/styles';
import FA from './FontAwesome';

const InputField = styled.input`
  flex: 1;
  padding: 5px;
  border: 1px solid ${COLOR.lightGray};
  outline: none;
  background: ${(props) => (props.disabled ? '#eee' : 'none')};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  ${InputField}:first-child {
    border-radius: 3px 0 0 3px;
  }
  ${InputField}:last-child {
    border-radius: 0 3px 3px 0;
  }
`;

const IconWrapper = styled.span`
  border: 1px solid ${COLOR.lightGray};
  border-left: none;
  border-right: none;
  padding: 0 8px;
  align-self: stretch;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f4f4f4;
`;

const Icon = ({ children, ...props }: StyledComponentPropsWithRef<typeof IconWrapper>) => {
  return <IconWrapper {...props}>{children ?? <FA icon="arrow-right" />}</IconWrapper>;
};

const RangeInput = ({ children, ...props }: HtmlHTMLAttributes<HTMLDivElement>) => {
  return <Wrapper {...props}>{children}</Wrapper>;
};
RangeInput.Field = InputField;
RangeInput.Icon = Icon;

export default styled(RangeInput)``;
